<div class="main__container">

	<breadcrumb></breadcrumb>

	<div class="section__container">
		<div class="box__container titulo__container">
			<p class="titulo">Reporte de Violencia Laboral</p>
		</div>

		<div class="contenido__box">
			<div class="contenido__container" [managedLink]="violenciaLaboralFormKey">
				<img src="/assets/images/reporte/violencia-laboral.png" >
			</div>

		</div>
	</div>
</div>

